export default defineNuxtPlugin({
  setup() {
    const script = document.createElement('script')
    script.src =
      'https://ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js'
    script.integrity =
      'sha384-rY/jv8mMhqDabXSo+UCggqKtdmBfd3qC2/KvyTDNQ6PcUJXaxK1tMepoQda4g5vB'
    script.crossOrigin = 'anonymous'
    script.async = true
    document.head.appendChild(script)
  },
})
